import axios from '@/axios';
import { showErrorMessage } from '@/utils';

const titleMap = {
  fnc: "Investigation Request Process",
  internal_issue: "Investigation Internal Issue",
  customer_issue: "Investigation Customer Issue",
  setlement_issue: "Settlement Approval Process"
  // add more mappings as needed
};

function groupByToArray(array, keyFn, titleMap = {}) {
  const grouped = {};

  for (const item of array) {
    const key = keyFn(item);
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(item);
  }

  return Object.entries(grouped).map(([key, items]) => {
    const is_completed = items.every(p => p.status === 'complete');

    return {
      key,
      title: titleMap[key] || key,
      processes: items,
      is_completed
    };
  });
}

function getWorkflows(workflows) {
  if (Array.isArray(workflows)) {
    return groupByToArray(workflows, ({ type }) => type.value, titleMap);
  } else {
    return [];
  }
}

const actions = {
  async getDetailFeedbackComplaint({ commit, dispatch }, id) {
    try {
      dispatch('toggleLoadingProgress', true, { root: true })
      const response = await axios.get(`/fnc/${id}`)

      if (response.status === 200) {
        const { data } = response.data
        const detail = {
          ...data,
          feedbackProcesses: getWorkflows(data?.workflows)
        }

        commit('SET_FEEDBACK_COMPLAINT', {
          type: 'detail',
          data: detail
        })
      }
    } catch (error) {
      showErrorMessage(error)
    } finally {
      dispatch('toggleLoadingProgress', false, { root: true })
    }
  },
  async getDetailFeedbackComplaintInternalIssue({ commit }, id) {
    try {
      const { data: responseData, status } = await axios.get(`/fnc-internal-issues/${id}`);
      if (status === 200 && responseData?.data) {
        commit('SET_FEEDBACK_COMPLAINT', {
          type: 'internalIssue',
          data: responseData.data
        })
      }
    } catch (error) {
      showErrorMessage(error);
    }
  },

  async getDetailFeedbackComplaintCustomerIssue({ commit }, id) {
    try {
      const { data: responseData, status } = await axios.get(`/fnc-customer-issues/${id}`);
      if (status === 200 && responseData?.data) {
        commit('SET_FEEDBACK_COMPLAINT', {
          type: 'customerIssue',
          data: responseData.data
        })
      }
    } catch (error) {
      showErrorMessage(error);
    }
  },

  async getDetailFeedbackComplaintSettlementIssue({ commit }, id) {
    try {
      const { data: responseData, status } = await axios.get(`/fnc-settlements/${id}`);
      if (status === 200 && responseData?.data) {
        commit('SET_FEEDBACK_COMPLAINT', {
          type: 'settlementIssue',
          data: responseData.data
        })
      }
    } catch (error) {
      showErrorMessage(error);
    }
  },
}

export default actions
